function Title() {
  return (
    <>
        <div className='flex flex-col'>
            <h1 style={{ fontFamily: 'Megrim'}} className='text-4xl text-center'>Hunger Grimoire</h1>
            <h2 className='text-center'>Invoque ton festin avec ce que cache ton garde-manger</h2>
        </div>
    </>
  );
}

export default Title;